export const routeNames = {
    // Auth
    LOGIN_VIEW_NAME: 'LOGIN_VIEW',
    FORGOT_PASSWORD_VIEW_NAME: 'FORGOT_PASSWORD_VIEW_NAME',
    FORGOT_PASSWORD_SET_NEW_PASSWORD_VIEW_NAME: 'FORGOT_PASSWORD_SET_NEW_PASSWORD_VIEW_NAME',
    // Views
    HOME_VIEW_NAME: 'HOME_VIEW',
    SUB_ACCOUNT_PROFILE_VIEW_NAME: 'SUBACCOUNT_VIEW_NAME',
    REPORTS_VIEW_NAME: 'REPORTS_VIEW_NAME',
    MESSAGES_VIEW_NAME: 'MESSAGES_VIEW_NAME',
    REPORT_EDIT_VIEW_NAME: 'REPORT_EDIT_VIEW_NAME',
    MESSAGES_LIST_VIEW_NAME: 'MESSAGES_LIST_VIEW_NAME',
    MESSAGE_DETAILS_VIEW_NAME: 'MESSAGE_DETAILS_VIEW_NAME',
    MESSAGE_EDIT_VIEW_NAME: 'MESSAGE_EDIT_VIEW_NAME',
    // RODO
    RODO_GUARDIAN_VIEW_NAME: 'ROOT_VIEW_NAME',
    CHILD_PROTECTION_VIEW_NAME: 'CHILD_PROTECTION_VIEW_NAME',
    RODO_SUB_ACCOUNT_VIEW_NAME: 'ROOT_SUB_ACCOUNT_VIEW_NAME',
    // Not found
    PAGE_NOT_FOUND_VIEW_NAME: 'PAGE_NOT_FOUND_VIEW_NAME',
    // Invitation
    INVITATION_VIEW_NAME: 'INVITATION_VIEW_NAME',
}
